const routes = [
  {
    path: 'monthly-planning',
    name: 'monthlyPlanning',
    component: () => import(/* webpackChunkName: "monthly-planning" */ './views/MonthlyPlanning.vue'),
    meta: {
      permissionRequired: false,
    },
  },
];

export default routes;
